// src/components/DepartmentAssistants.jsx
import React from 'react';
import { } from 'lucide-react'; // (kept in case you want icons later)
import '../styles/service-style/medical-rehabilitation.css';

// Images (use the same ones you already imported in service pages)
import manikanth from '../assets/Rehab staff/Manikanth.JPG';
import SaiKumarYadav from '../assets/Rehab staff/Sai kumar Yadav.JPG';
import saiKiran from '../assets/Rehab staff/Sai kiran.JPG';
import praveen from '../assets/profile.png'; // your file points to this path for Praveen
import manohar from '../assets/Rehab staff/Manohar.JPG'; // your file points to this path for Praveen

const assistants = [
    {
        name: 'Mr. N. Shravan',
        role: 'Dept. Assistant — Physiotherapy',
        bio: 'Supports therapy workflow and patient care coordination.',
        image: manikanth,
    },
    {
        name: 'Mr. Ch. Sai Yadav',
        role: 'Dept. Assistant — Occupational Therapy',
        bio: 'Assists with ADL/IADL sessions and patient scheduling.',
        image: SaiKumarYadav,
    },
    {
        name: 'Mr. D. Sai Kiran',
        role: 'Dept. Assistant — Speech & Language',
        bio: 'Coordinates SLP sessions and supports device setup.',
        image: saiKiran,
    },
    {
        name: 'Mr. S. Praveen',
        role: 'Dept. Assistant — Psychology',
        bio: 'Helps manage group sessions and program logistics.',
        image: praveen,
    },
    {
        name: 'Mr. Manohar',
        role: 'Warden',
        bio: 'Helps manage group sessions and program logistics.',
        image: manohar,
    },
    // Add more assistants here as you confirm departments/images
];

const DepartmentAssistants = () => {
    return (
        <section className="rehab-team" style={{ paddingTop: 24 }}>
            <h2 className="rehab-section-title">Department Assistants</h2>
            <div className="rehab-team-grid">
                {assistants.map((member, idx) => (
                    <div key={idx} className="rehab-team-card">
                        <div className="rehab-team-img">
                            <img src={member.image} alt={member.name} />
                        </div>
                        <div className="rehab-team-info">
                            <h3>{member.name}</h3>
                            <p className="role">{member.role}</p>
                            <p className="bio">{member.bio}</p>
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default DepartmentAssistants;
